import { createContext, useContext } from "react";

export const LanguageContext = createContext<string>("language");

export const useLanguage = () => useContext(LanguageContext);
